import Vue from 'vue';
import Router from 'vue-router';
const _import2 = require('./_import_production');
import Layout from '@/page/layout/index.vue';
import s1 from '@/page/login/index1.vue';
import s2 from '@/page/home/index.vue';
import s3 from '@/page/pCenter/index.vue';
import s4 from '@/page/edit/index.vue';
import s5 from '@/page/assign/index.vue';
import s6 from '@/page/zone/list.vue';
import s7 from '@/page/zone/detail.vue';
import s8 from '@/page/contract/list.vue';
import s9 from '@/page/information/list.vue';
import s10 from '@/page/information/detail.vue';
import s11 from '@/page/accept/index.vue';
import s12 from '@/page/record/index.vue';
import s17 from '@/page/academy/recordList.vue';
import s19 from '@/page/academy/child/task-detail.vue';
import s24 from '@/page/digital/recordList.vue';
import s26 from '@/page/digital/child/task-detail.vue';
import s31 from '@/page/spread/recordList.vue';
import s32 from '@/page/spread/child/recordDetail.vue';

import s36 from '@/page/otc/recordList.vue';
import s37 from '@/page/download/list.vue';
import s40 from '@/page/case/child/recordAdd-edit.vue';
import s45 from '@/page/case/recordList.vue';
import s46 from '@/page/zsCase/child/recordAdd-edit.vue';
import s51 from '@/page/zsCase/recordList.vue';
import s57 from '@/page/ksh/recordList.vue';
import s62 from '@/page/hjh/recordList.vue';
import s67 from '@/page/survey/recordList.vue';
import s68 from '@/page/survey/child/recordDetail.vue';
import s75 from '@/page/yshSurvey/recordList.vue';
import s76 from '@/page/yshSurvey/child/recordDetail.vue';
import s84 from '@/page/lvlHospital/recordList.vue';
import s86 from '@/page/lvlHospital/child/task-detail.vue';
import s91 from '@/page/baseHospital/recordList.vue';
import s93 from '@/page/baseHospital/child/task-detail.vue';
import s94 from '@/page/editScene/child/recordDetail.vue';
import s95 from '@/components/Task/components/AcceptDetail.vue';
import s44 from '@/page/BI/index.vue';
import s44_1 from '@/page/BI-old/index.vue';

import s96 from '@/page/invoice/list.vue';
import s97 from '@/page/dutypaidProof/list.vue';
import s98 from '@/page/digitalQuestionnaire/child/recordDetail.vue';

import { s51 as s50, s52, s53 } from '@/page/accountManagement';

Vue.use(Router);

//设置拜访场景
const setMoudle = (basePath, name) => {
  const _basePath = basePath;
  return {
    path: `/${_basePath}`,
    name: _basePath,
    component: Layout,
    redirect: `/${_basePath}/recordList`,
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: name,
      asideName: name
    },
    children: [
      {
        path: `/${_basePath}/recordList`,
        name: `${_basePath}RecordList`,
        component: _import2(`/${_basePath}/recordList`),
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '拜访记录',
          index: 2,
          selfName: '拜访记录',
          parentIndex: 0,
          parentUrl: `/${_basePath}/projectList`
        }
      },
      {
        path: `/${_basePath}/clientList`,
        name: `${_basePath}ClientList`,
        component: _import2(`/${_basePath}/clientList`),
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '客户管理',
          index: 0,
          selfName: '客户管理'
        }
      },
      {
        path: `/${_basePath}/record${_basePath}lDetail`,
        name: `record${_basePath}lDetail`,
        component: _import2(`/${_basePath}/child/task-detail`),
        meta: {
          name: '详情'
        }
      }
    ]
  };
};

const constantRouterMapArr = [
  {
    path: '/login',
    name: 'login',
    component: s1,
    hidden: true
  },
  {
    path: '/accept/bi',
    component: s44,
    name: 'bi',
    meta: {
      index: 0,
      name: 'BI报表',
      selfName: 'BI报表'
    }
  },
  {
    path: '/accept/bi-old',
    component: s44_1,
    name: 'bi-old',
    meta: {
      index: 0,
      name: 'BI报表',
      selfName: 'BI报表'
    }
  },
  {
    path: '/home',
    redirect: '/v3/home/index'
  },
  {
    path: '/',
    component: Layout,
    redirect: '/v3/home/index',
    meta: {
      headerNavName: '首页',
      asideName: '首页'
    },
    children: [
      {
        path: '/v3/home/index',
        name: 'home',
        meta: {
          index: 0,
          name: '首页',
          selfName: '首页',
          vue3: true
        }
      }
    ]
  },
  {
    path: '/v3/zs-manage',
    component: Layout,
    name: 'zs-manage',
    redirect: '/v3/zs-manage/config',
    children: [
      {
        path: '/v3/zs-manage/config',
        name: 'zs-manage-config',
        meta: { name: '招商配置', vue3: true }
      },
      {
        path: '/v3/zs-manage/drug',
        name: 'zs-manage-drug',
        meta: { name: '药品管理', vue3: true }
      },
      {
        path: '/v3/zs-manage/device',
        name: 'zs-manage-device',
        meta: { name: '器械管理', vue3: true }
      },
      {
        path: '/v3/zs-manage/ability',
        name: 'zs-manage-ability',
        meta: { name: '能力标签', vue3: true }
      },
      {
        path: '/v3/zs-manage/person',
        name: 'zs-manage-person',
        meta: { name: '人员管理', vue3: true }
      }
    ]
  },
  {
    path: '/v3/digtal-storage',
    component: Layout,
    name: 'digtal-storage',
    redirect: '/v3/digtal-storage/digtal-storage-list',
    meta: {
      headerNavName: '数字存证管理',
      asideName: '数字存证管理'
    },
    children: [
      {
        path: '/v3/digtal-storage/digtal-storage-list',
        name: 'digtal-storage-list',
        meta: {
          name: '数字存证管理',
          vue3: true,
          asideInMain: true
        }
      }
    ]
  },
  // vue3路由
  {
    path: '/v3/*',
    component: Layout,
    name: 'v3-project',
    meta: {
      hasAside: true,
      asideName: 'projectAsideList'
    },
    children: [
      {
        path: '/v3/task-progress/list',
        name: 'v3-task-progress-list',
        meta: {
          name: '任务进度',
          hasAside: true,
          asideName: 'projectAsideList',
          vue3: true
        }
      },
      {
        path: '/v3/persontask-progress/list',
        name: 'v3-persontask-progress-list',
        meta: {
          name: '项目执行人任务进度',
          vue3: true
        }
      },
      {
        path: '/v3/settlement/index',
        name: 'v3-settlement-center',
        meta: {
          name: '结算中心',
          vue3: true
        }
      },
      {
        path: '/v3/questionnaire/list',
        name: 'v3-questionnaire-list',
        meta: {
          name: '首页',
          vue3: true
        }
      }
    ]
  },
  {
    path: '/pCenter',
    name: 'pCenter',
    component: Layout,
    meta: {
      headerNavName: '个人中心',
      asideName: '个人中心'
    },
    children: [
      {
        path: '/pCenter/index',
        component: s3,
        meta: {
          index: 0,
          name: '个人中心',
          selfName: '个人中心'
        }
      }
    ]
  },
  {
    path: '/edit',
    name: 'edit',
    component: Layout,
    meta: {
      headerNavName: '编辑项目',
      asideName: '编辑项目'
    },
    children: [
      {
        path: '/edit/index',
        component: s4,
        meta: {
          index: 0,
          name: '编辑项目',
          selfName: '编辑项目'
        }
      },
      {
        path: '/edit/index-next',
        component: s4,
        meta: {
          index: 0,
          name: '编辑项目',
          selfName: '编辑项目'
        }
      }
    ]
  },
  {
    path: '/assign',
    name: 'assign',
    component: Layout,
    meta: {
      headerNavName: '下发任务',
      asideName: '下发任务'
    },
    children: [
      {
        path: '/assign/index',
        component: s5,
        meta: {
          index: 0,
          name: '下发任务',
          selfName: '下发任务'
        }
      }
    ]
  },
  {
    path: '/zone',
    name: 'zone',
    component: Layout,
    meta: {
      headerNavName: '专区列表',
      asideName: '专区列表'
    },
    children: [
      {
        path: 'list',
        name: 'zoneList',
        component: s6,
        meta: {
          index: 0,
          name: '专区列表',
          selfName: '专区列表'
        }
      },
      {
        path: 'detail',
        name: 'zoneDetail',
        component: s7,
        meta: {
          index: 0,
          name: '专区列表',
          selfName: '专区列表'
        }
      }
    ]
  },
  {
    path: '/contract',
    name: 'contract',
    component: Layout,
    meta: {
      headerNavName: '电子合同管理',
      asideName: '电子合同管理'
    },
    children: [
      {
        path: 'list',
        name: 'contractList',
        component: s8,
        meta: {
          index: 0,
          name: '电子合同列表',
          selfName: '电子合同列表'
        }
      }
    ]
  },
  {
    path: '/information',
    name: 'information',
    component: Layout,
    meta: {
      headerNavName: '专区列表',
      asideName: '专区列表'
    },
    children: [
      {
        path: 'list',
        name: 'informationList',
        component: s9,
        meta: {
          index: 0,
          name: '专区列表',
          selfName: '专区列表'
        }
      },
      {
        path: 'detail',
        name: 'informationDetail',
        component: s10,
        meta: {
          index: 0,
          name: '专区列表',
          selfName: '专区列表'
        }
      }
    ]
  },
  {
    path: '/accept',
    name: 'accept',
    component: Layout,
    meta: {
      headerNavName: '接受任务',
      asideName: '接受任务'
    },
    children: [
      {
        path: '/accept/index',
        name: 'accept',
        component: s11,
        meta: {
          index: 0,
          name: '接受任务',
          selfName: '接受任务'
        },
        children: []
      },
      {
        path: 'detail',
        name: 'acceptDetail',
        component: s95,
        meta: {
          index: 0,
          name: '查看详情',
          selfName: '查看详情'
        }
      }
    ]
  },
  {
    path: '/record',
    name: 'record',
    component: Layout,
    meta: {
      headerNavName: '任务记录',
      asideName: '任务记录'
    },
    children: [
      {
        path: '/record/index',
        component: s12,
        meta: {
          index: 0,
          name: '任务记录',
          selfName: '任务记录'
        }
      }
    ]
  },
  {
    path: '/academy',
    name: 'academy',
    component: Layout,
    redirect: '/academy/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '学术拜访',
      asideName: '学术拜访'
    },
    children: [
      {
        path: '/academy/recordList',
        name: 'academyRecordList',
        component: s17,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '拜访记录',
          index: 2,
          selfName: '拜访记录',
          parentIndex: 0,
          parentUrl: '/academy/projectList'
        }
      },
      {
        path: '/academy/recordAcademylDetail',
        name: 'recordAcademylDetail',
        component: s19,
        meta: {
          name: '详情'
        }
      }
    ]
  },
  {
    path: '/digital',
    name: 'digital',
    component: Layout,
    redirect: '/digital/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '数字拜访',
      asideName: '数字拜访'
    },
    children: [
      {
        path: '/digital/recordList',
        name: 'digitalRecordList',
        component: s24,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '拜访记录',
          index: 2,
          selfName: '拜访记录',
          parentIndex: 0,
          parentUrl: '/digital/projectList'
        }
      },
      {
        path: '/digital/recordDigitallDetail',
        name: 'recordDigitallDetail',
        component: s26,
        meta: {
          name: '详情'
        }
      }
    ]
  },
  {
    path: '/spread',
    name: 'spread',
    component: Layout,
    redirect: '/spread/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '线上推广',
      asideName: '线上推广'
    },
    children: [
      {
        path: '/spread/recordList',
        name: 'spreadRecordList',
        component: s31,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '线上推广列表',
          index: 2,
          selfName: '线上推广列表',
          parentIndex: 0,
          parentUrl: '/spread/projectList'
        }
      },
      {
        path: '/spread/recordDetail',
        name: 'spreadRecordDetail',
        component: s32,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/spread/projectList'
        }
      }
    ]
  },
  {
    path: '/otc',
    name: 'otc',
    component: Layout,
    redirect: '/otc/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: 'OTC巡店',
      asideName: 'OTC巡店'
    },
    children: [
      {
        path: '/otc/recordList',
        name: 'otcRecordList',
        component: s36,
        meta: {
          name: 'OTC巡店',
          index: 2,
          selfName: '巡店记录',
          parentIndex: 0,
          parentUrl: '/otc/projectList'
        }
      }
    ]
  },
  {
    path: '/case',
    name: 'case',
    component: Layout,
    redirect: '/case/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '病例项目管理',
      asideName: '病例项目管理'
    },
    children: [
      {
        path: '/case/recordAdd-edit',
        name: 'caseRecordAddEdit',
        component: s40,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '病例列表',
          index: 1,
          parentIndex: 0,
          parentUrl: '/case/recordList',
          selfName: '详情'
        }
      },
      {
        path: '/case/recordList',
        name: 'caseRecordList',
        component: s45,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '病例管理',
          index: 2,
          selfName: '病例列表',
          parentIndex: 0,
          parentUrl: '/case/projectList'
        }
      }
    ]
  },
  {
    path: '/zsCase',
    name: 'zsCase',
    component: Layout,
    redirect: '/zsCase/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '病例项目管理',
      asideName: '病例项目管理'
    },
    children: [
      {
        path: '/zsCase/recordAdd-edit',
        name: 'zsCaseRecordAddEdit',
        component: s46,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '病例列表',
          index: 1,
          parentIndex: 0,
          parentUrl: '/zsCase/recordList',
          selfName: '详情'
        }
      },
      {
        path: '/zsCase/recordList',
        name: 'zsCaseRecordList',
        component: s51,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '病例管理',
          index: 2,
          selfName: '病例列表',
          parentIndex: 0,
          parentUrl: '/zsCase/projectList'
        }
      }
    ]
  },
  {
    path: '/protocolService',
    name: 'protocolService',
    component: Layout,
    redirect: '/protocolService/recordList',
    meta: {
      headerNavName: '协定服务管理',
      asideName: '协定服务管理'
    },
    children: [
      {
        path: '/protocolService/recordAdd-edit',
        name: 'protocolServiceRecordAddEdit',
        component: _import2(`/protocolService/child/recordAdd-edit`),
        meta: {
          name: '协定服务列表',
          index: 1,
          parentIndex: 0,
          parentUrl: '/protocolService/recordList',
          selfName: '详情'
        }
      },
      {
        path: '/protocolService/recordList',
        name: 'protocolServiceRecordList',
        component: _import2(`/protocolService/recordList`),
        meta: {
          name: '协定服务管理',
          index: 2,
          selfName: '协定服务列表',
          parentIndex: 0,
          parentUrl: '/protocolService/projectList'
        }
      }
    ]
  },
  {
    path: '/editScene',
    name: 'editScene',
    component: Layout,
    redirect: '/editScene/recordList',
    meta: {
      headerNavName: '可配置场景管理',
      asideName: '可配置场景管理'
    },
    children: [
      {
        path: '/editScene/recordList',
        name: 'editSceneRecordList',
        component: _import2(`/editScene/recordList`),
        meta: {
          name: '可配置场景管理',
          index: 2,
          selfName: '可配置场景列表',
          parentIndex: 0,
          parentUrl: '/editScene/projectList'
        }
      },
      {
        path: '/editScene/recordDetail',
        name: 'editSceneRecordDetail',
        component: s94,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/editScene/projectList'
        }
      }
    ]
  },
  {
    path: '/digitalQuestionnaire',
    name: 'digitalQuestionnaireRecordList',
    component: Layout,
    redirect: '/digitalQuestionnaire/recordList',
    meta: {
      headerNavName: '数字问卷场景管理',
      asideName: '数字问卷场景管理'
    },
    children: [
      {
        path: '/digitalQuestionnaire/recordList',
        name: 'digitalQuestionnaire',
        component: _import2(`/digitalQuestionnaire/recordList`),
        meta: {
          name: '数字问卷场景管理',
          index: 2,
          selfName: '数字问卷场景列表',
          parentIndex: 0,
          parentUrl: '/digitalQuestionnaire/projectList'
        }
      },
      {
        path: '/digitalQuestionnaire/recordDetail',
        name: 'digitalQuestionnaireRecordDetail',
        component: s98,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/digitalQuestionnaire/projectList'
        }
      }
    ]
  },
  {
    path: '/ksh',
    name: 'ksh',
    component: Layout,
    redirect: '/ksh/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '科室会管理',
      asideName: '科室会管理'
    },
    children: [
      {
        path: '/ksh/recordList',
        name: 'kshRecordList',
        component: s57,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '科室会管理',
          index: 2,
          selfName: '会议列表',
          parentIndex: 0,
          parentUrl: '/ksh/projectList'
        }
      }
    ]
  },
  {
    path: '/hjh',
    name: 'hjh',
    component: Layout,
    redirect: '/hjh/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '患教会管理',
      asideName: '患教会管理'
    },
    children: [
      {
        path: '/hjh/recordList',
        name: 'hjhRecordList',
        component: s62,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '患教会管理',
          index: 2,
          selfName: '会议记录',
          parentIndex: 0,
          parentUrl: '/hjh/projectList'
        }
      }
    ]
  },
  {
    path: '/survey',
    name: 'survey',
    component: Layout,
    redirect: '/survey/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '项目调研',
      asideName: '项目调研'
    },
    children: [
      {
        path: '/survey/recordList',
        name: 'surveyRecordList',
        component: s67,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/survey/projectList'
        }
      },
      {
        path: '/survey/recordDetail',
        name: 'surveyRecordDetail',
        component: s68,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/survey/projectList'
        }
      }
    ]
  },
  {
    path: '/yshSurvey',
    name: 'yshSurvey',
    component: Layout,
    redirect: '/yshSurvey/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: 'OTC巡店',
      asideName: 'OTC巡店'
    },
    children: [
      {
        path: '/yshSurvey/recordList',
        name: 'yshSurveyRecordList',
        component: s75,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/yshSurvey/projectList'
        }
      },
      {
        path: '/yshSurvey/recordDetail',
        name: 'yshSurveyRecordDetail',
        component: s76,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '任务记录',
          index: 2,
          selfName: '任务记录',
          parentIndex: 0,
          parentUrl: '/yshSurvey/projectList'
        }
      }
    ]
  },
  {
    path: '/lvlHospital',
    name: 'lvlHospital',
    component: Layout,
    redirect: '/lvlHospital/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '学术拜访',
      asideName: '学术拜访'
    },
    children: [
      {
        path: '/lvlHospital/recordList',
        name: 'lvlHospitalRecordList',
        component: s84,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '拜访记录',
          index: 2,
          selfName: '拜访记录',
          parentIndex: 0,
          parentUrl: '/lvlHospital/projectList'
        }
      },

      {
        path: '/lvlHospital/recordlvlHospitallDetail',
        name: 'recordlvlHospitallDetail',
        component: s86,
        meta: {
          name: '详情'
        }
      }
    ]
  },
  {
    path: '/baseHospital',
    name: 'baseHospital',
    component: Layout,
    redirect: '/baseHospital/recordList',
    meta: {
      //一级需要NavName与asideName 对应当前激活
      headerNavName: '基层医院拜访',
      asideName: '基层医院拜访'
    },
    children: [
      {
        path: '/baseHospital/recordList',
        name: 'baseHospitalRecordList',
        component: s91,
        meta: {
          // child {name} 寻找对应aside   {index} 用于面包屑路径查找
          name: '拜访记录',
          index: 2,
          selfName: '拜访记录',
          parentIndex: 0,
          parentUrl: '/baseHospital/projectList'
        }
      },
      {
        path: '/baseHospital/recordbaseHospitallDetail',
        name: 'recordbaseHospitallDetail',
        component: s93,
        meta: {
          name: '详情'
        }
      }
    ]
  },
  {
    path: '/download',
    component: Layout,
    redirect: '/download/list',
    name: 'download',
    meta: {
      headerNavName: '下载中心',
      asideName: '下载中心'
    },
    children: [
      {
        path: 'list',
        name: 'downloadList',
        component: s37,
        meta: {
          index: 0,
          name: '下载中心',
          selfName: '下载中心'
        }
      }
    ]
  },
  {
    path: '/accountManagement',
    component: Layout,
    name: 'accountManagement',
    redirect: '/accountManagement/subAccountManagement',

    meta: {
      headerNavName: '账号管理',
      asideName: '账号管理'
    },
    children: [
      {
        path: 'subAccountManagement',
        name: 'subAccountManagement',
        component: s50,
        meta: {
          index: 0,
          name: '子账号管理',
          selfName: '子账号管理'
        }
      },
      {
        path: 'operationLog',
        name: 'operationLog',
        component: s52,
        meta: {
          index: 1,
          name: '操作日志',
          selfName: '操作日志'
        }
      },
      {
        path: 'mainAccountManagement',
        name: 'mainAccountManagement',
        component: s53,
        meta: {
          index: 2,
          name: '主账号管理',
          selfName: '主账号管理'
        }
      }
    ]
  },
  {
    path: '/dutypaidProof',
    name: 'dutypaidProof',
    redirect: '/dutypaidProof/list',
    component: Layout,
    meta: {
      headerNavName: '完税证明',
      asideName: '完税证明'
    },
    children: [
      {
        path: 'list',
        name: 'dutypaidProofList',
        component: s97,
        meta: {
          index: 0,
          name: '完税证明列表',
          selfName: '完税证明列表'
        }
      }
    ]
  },
  {
    path: '/invoice',
    name: 'invoice',
    redirect: '/invoice/list',
    component: Layout,
    meta: {
      headerNavName: '发票管理',
      asideName: '发票管理'
    },
    children: [
      {
        path: 'list',
        name: 'invoiceList',
        component: s96,
        meta: {
          index: 0,
          name: '发票管理列表',
          selfName: '发票管理列表'
        }
      }
    ]
  }
];

constantRouterMapArr.push(
  //特级市场准入
  setMoudle('accessSuper', '特级三甲医院市场准入'),
  //二级市场准入
  setMoudle('accessSecond', '三级医院市场准入'),
  //三级市场准入
  setMoudle('accessThird', '二级医院市场准入'),
  //基层医疗市场准入
  setMoudle('accessBase', '基层医疗机构市场准入'),
  //药店市场准入
  setMoudle('accessRetail', '零售药店市场准入')
);

export let constantRouterMap = constantRouterMapArr;

export default new Router({
  // mode: 'history',  require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
export const asyncRouterMap = [];
